import CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';
import FolderChange from 'owa-service/lib/contract/FolderChange';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import updateFolderOperation from 'owa-service/lib/operation/updateFolderOperation';
import updateFolderRequest from 'owa-service/lib/factory/updateFolderRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { MailboxInfo } from 'owa-client-ids';

/**
 * Renames calendar on server
 * @param calendar instance of calendar
 * @param newCalendarName new calendar name
 */
export default function updateFolderService(
    folderChange: FolderChange,
    mailboxInfo: MailboxInfo
): Promise<CalendarActionResponse> {
    const requestOptions = getMailboxRequestOptions(mailboxInfo);

    return updateFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: updateFolderRequest({
                FolderChanges: [folderChange],
            }),
        },
        requestOptions
    ).then(response => {
        let responseMessage = response.Body.ResponseMessages.Items[0];
        return {
            WasSuccessful: responseMessage.ResponseClass == 'Success',
        };
    });
}
